const products = [
    {
        name: "Heizöl Standard",
        description:
            "Qualität nach DIN mit garantiert niedrigem Schwefelgehalt.",
        price: "+ 0,00 € Preis 100l inkl. MwSt.",
        premiumVal: false,
    },
    {
        name: "Eco-Super-Heizöl",
        description:
            "Hierbei handelt es sich um unser durch Additive verbessertes Heizöl Standard schwefelarm.",
        price: "+ 2,53 € Preis 100l inkl. MwSt.",
        premiumVal: true,
    },
];

export default products;
